<template>
  <div
    id="echart-media"
    style="width: 100%; height: 95%; margin-top: 3.5rem"
  ></div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "OpinionMediaTop5",
  controller: "UI",
  action: "OpinionMediaTop5",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      let that = this;
      let searchInfo = {
        BeginTime: new Date(new Date().getFullYear() + "-01" + "-01"),
        EndTime: new Date(),
      };
      new MyApis.OpinionApi()
        .GetMediaTop10(searchInfo)
        .then((r) => {
          r = r.data.Data;

          that.drawChart(r);
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    drawChart(data) {
      if (data) {
        var legendData = [];
        var seriesData = [];
        for (var i = 0; i < data.length; i++) {
          var item = data[i];
          seriesData.push({
            name: item.WebSiteName,
            value: item.TotalCount,
          });
          legendData.push(item.WebSiteName);
        }
        var arr = [],
          arr01 = [];
        data.reverse().map((x) => {
          arr.push(x.TotalCount);
          arr01.push(x.WebSiteName);
        });
        // eslint-disable-next-line no-undef
        var myChart = echarts.init(document.getElementById("echart-media"));
        var echartsColor = ["#2ac1ff","#e6a23c","#f56c6c","#67c23a","#cf9236","#257dd4","#91c7ae"]
        // eslint-disable-next-line no-undef
        var colors = echartsColor.slice(
          // eslint-disable-next-line no-undef
          parseInt((Math.random() * echartsColor.length) / 2)
        );
        var Max = this.calMax(arr);
        myChart.setOption({
          color: colors,
          title: {
            show: false,
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          grid: {
            left: "0",
            right: "10%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "value",
            min: 0,
            max: Max,
            interval: Max / 5,
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                //图例文字的样式
                // fontSize: 0.18*this.baseFontSize,
                color: "#bbb",
              },
            },
          },
          yAxis: {
            type: "category",
            data: arr01,
            axisLabel: {
              interval: 0,
              showMaxLabel: true,
              textStyle: {
                //图例文字的样式
                color: "#999",
                // fontSize: 0.2*this.baseFontSize
              },
            },
          },
          series: [
            {
              name: "",
              type: "bar",
              data: arr,
            },
          ],
        });
      }
    },
    calMax(arr) {
      let max = Math.max(...arr);
      let maxint = Math.ceil(max / 9.5); // 不让最高的值超过最上面的刻度
      let maxval = maxint * 10; // 让显示的刻度是整数

      // 为了防止数据为0时，Y轴不显示，给个最大值
      if (maxval == 0) {
        maxval = 1;
      }
      return maxval;
    },
  },
};
</script>